'use strict'

class AboutUs {
	constructor(props) {
		console.log('AboutUs::constructor(%o)', props);
		let _that = this;

		_that.callbacks = {};

		_that.timeline_titles = document.querySelectorAll('.date-title');

		if (typeof Object.assign == 'function') {
			_that = Object.assign(this, props);
		}

		_that.pageEvents();
	}

	pageEvents() {
		let _that = this;

		const first_news_wrapper = document.querySelectorAll('.news-wrapper')[0];
		const first_news_wrapper_box = first_news_wrapper.querySelector('.news-wrapper-box');
		first_news_wrapper.style.height = first_news_wrapper_box.clientHeight + 'px';

		if (_that.timeline_titles.length > 0) {
			for (let i = 0; i < _that.timeline_titles.length; i++) {
				if (_that.timeline_titles[i].addEventListener) {
					_that.timeline_titles[i].addEventListener('click', function () {
						this.classList.toggle('collapsed');
						const news_wrapper = this.parentElement.querySelector('.news-wrapper');
						if (news_wrapper.clientHeight) {
							news_wrapper.style.height = 0;
						} else {
							const news_wrapper_box = this.parentElement.querySelector('.news-wrapper-box');
							news_wrapper.style.height = news_wrapper_box.clientHeight + 'px';
						}
						this.parentElement.querySelector('.news-wrapper').classList.toggle('collapsed');
					});
				} else {
					_that.timeline_titles[i].attachEvent('onclick', function () {
						this.classList.toggle('collapsed');
						const news_wrapper = this.parentElement.querySelector('.news-wrapper');
						if (news_wrapper.clientHeight) {
							news_wrapper.style.height = 0;
						} else {
							const news_wrapper_box = this.parentElement.querySelector('.news-wrapper-box');
							news_wrapper.style.height = news_wrapper_box.clientHeight + 'px';
						}
						this.parentElement.querySelector('.news-wrapper').classList.toggle('collapsed');
					});
				}
			}
		}
	}

	emitCallback(name, params = null) {
		let _that = this;

		if (typeof _that.callbacks[name] === 'function') {
			try {
				console.log('AboutUs::emitCallback(%o, %o)', name, params);
				_that.callbacks[name].call(this, params);
			} catch (e) {
				console.log(e);
			}
		} else {
			console.log('AboutUs::emitCallback(%o, %o) not defined', name, params);
		}
	}
}